import React from 'react';
import './box.scss';

interface ProductParametersProps {
    title?: string;
    titlePosition?: 'left'|'right'|'center';
    anchorIdName?: string;
    className?: string;
    headerTitle?: boolean;
}

const Box: React.FC<ProductParametersProps> = ({ title, anchorIdName, titlePosition, children, className, headerTitle }) => (
    <div className={`box ${className || ''}`} id={anchorIdName}>
        {title && (headerTitle
            ? (
                <h2 className={`box__title${titlePosition ? ` box__title--${titlePosition}` : ''}`}>
                    {title}
                </h2>
            )
            : (
                <div className={`box__title${titlePosition ? ` box__title--${titlePosition}` : ''}`}>
                    {title}
                </div>
            ))}
        {children}
    </div>
);

export default Box;
